export const SIZE = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
}

export const COLOR = {
  primary: 'primary',
  white: 'white',
  'carbon-light-600': 'carbon-light-600',
  carbon800: 'carbon-800',
}
